import React from "react";
import {
  ReferenceField,
  TextField,
  ChipField,
  NumberField,
  BooleanField,
} from "react-admin";
import { Card, CardContent, Typography, Box } from "@mui/material";

export const SubscriptionLimiterPlanInfo = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Информация о тарифе
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <ReferenceField
            source="subscriptionPlanId"
            reference="subscriptionPlans"
            label="План подписки"
            link="show"
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ChipField source="name" />
              <ChipField source="type" />
            </Box>
          </ReferenceField>

          <ReferenceField
            source="subscriptionPlanId"
            reference="subscriptionPlans"
            label=""
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <NumberField
                  source="price"
                  label="Цена"
                  options={{ style: "currency", currency: "USD" }}
                />
                <TextField source="currency" label="Валюта" />
              </Box>
              <NumberField
                source="billingPeriodMonths"
                label="Период оплаты (месяцы)"
              />
              <BooleanField source="isActive" label="План активен" />
            </Box>
          </ReferenceField>
        </Box>
      </CardContent>
    </Card>
  );
};
